<template>
    <div class="px-2 px-2 col-sm-12 col-lg-8">
        <div class="col-sm-12 col-lg-8 mb-1">
            <label class="form-label">Deal Title <span class="text-danger">*</span></label>
            <div class="input-group input-group-merge w-100">
                <input
                    v-model="formData.deal_title"
                    name="name"
                    type="text"
                    class="form-control"
                    placeholder="Deal Title"
                />
            </div>
        </div>

        <div class="col-sm-12 col-lg-8 mb-1">
            <label for="colFormLabel" class="col-form-label"> Product/Service </label>
            <AsyncSelect
              placeholder="Select Product/Service"
              :api-service="fetchProductList"
              v-model="productList"
              label="text"
              :reduce="text => text"
              :format-label="option => option.text"
              :multiple="true"
              ref="productSelector"
            />
        </div>

        <div class="col-sm-12 col-lg-8 mb-1">
            <label class="form-label">Product or Service Details</label>
            <div class="input-group input-group-merge w-100">
                <textarea 
                    v-model="formData.description"
                    name="reference" rows="2"
                    placeholder="Enter Details"
                    class="form-control add-credit-card-mask"
                >
                </textarea>
            </div>
        </div>

        <div class="col-sm-12 col-lg-8 mb-1">
            <label class="form-label">Expected Revenue</label>
            <div class="input-group input-group-merge w-100">
                <input
                    v-model="formData.est_deal_value"
                    name="name"
                    type="Number"
                    class="form-control"
                    placeholder="Expected Revenue"
                />
            </div>
        </div>

        <div class="col-sm-12 col-lg-8 mb-1">
            <label class="form-label">Expected Closing Date</label>
            <div class="input-group input-group-merge w-100">
                <input
                    name="date"
                    type="date"
                    class="form-control"
                    v-model="formData.exp_closing_date"
                />
            </div>
        </div>

        <div class="col-sm-12 col-lg-8 mb-1">
            <label class="form-label">Tag Register List</label>
            <AsyncSelect
                placeholder="Tag Register List"
                v-model="tagRegisterList"
                :api-service="fetchTagRegister"
                :reduce="text => text"
                :is-multiple="true"
            />
        </div>

        <div class="ccol-sm-12 col-lg-8 mb-1">
            <label class="form-label">Priority</label>
            <v-select
                placeholder="Select Priority"
                :options="priorityList" v-model="formData.priority_id"
                :reduce="option => option.id"
                label="name"
            />
        </div>

        <div class="col-sm-12 col-lg-8 mb-1">
            <label class="form-label">Probability %</label>
            <div class="input-group input-group-merge w-100">
                <input
                    v-model="formData.probability"
                    name="name"
                    type="Number"
                    class="form-control"
                />
            </div>
        </div>
     
    </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handlePurchase from '@/services/modules/purchase';
import handleTagRegister from '@/services/modules/scm/tag-register';

const props = defineProps({
    priorityList: Array,
})

const { fetchProductList } = handlePurchase();
const { fetchTagRegister } = handleTagRegister();

const productList = ref([]);
const tagRegisterList = ref([]);

const formData = reactive({
    deal_title: '',
    description: '',
    est_deal_value: null,
    exp_closing_date: new Date().toISOString().split('T')[0],
    probability: null,
    priority_id: null,
    item_details:[],
    tag_list: [],
})

const getFormData = () => {
    formData.item_details = productList.value.map(product => ({
        product_id: product.id,
        text: product.text
    }));

    formData.tag_list = tagRegisterList.value.map(tag => ({
        tag_register_id: tag.id,
        name: tag.name
    }));

    return { ...formData };
}

const setFormData = (data) => {
    formData.deal_title = data.deal_title || '';
    formData.description = data.description || '';
    formData.est_deal_value = data.est_deal_value || null;
    formData.exp_closing_date = data.exp_closing_date || '';
    formData.probability = data.probability || null;
    formData.priority_id = data.priority_id || null;

    if(data.item_details.length > 0) {
        productList.value = data.item_details.map(item => ({
            id: item.id,
            text: item.name
        })) || [];
    }
    
    if(data.tag_list.length > 0) {
        tagRegisterList.value = data.tag_list.map(tag => ({
            id: tag.id,
            name: tag.name
        })) || [];
    }
};

defineExpose({
  getFormData,
  setFormData
});
</script>